/**
 * Validates a US zipcode (5 digits)
 * @param zipcode - The zipcode string to validate
 * @returns boolean - true if valid, false otherwise
 */
export const validateZipcode = (zipcode: string): boolean => {
  const zipcodeRegex = /^\d{5}$/;
  return zipcodeRegex.test(zipcode);
};
